import { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print';
import DefaultData from '../../CompanyData/DefaultData';
const FlightVoucher = () => {
    const params = useParams();
    const contentRef = useRef();
    const [pageLoading, setPageLoading] = useState(false);
    const [bookingDetails, setBookingDetails] = useState({});
    const [travellers, setTravellers] = useState([]);
    const [itinerary, setItinerary] = useState([]);
    const handlePrint = useReactToPrint({
        content: () => contentRef.current,
    });
    const handlePDF = () => {
        const input = contentRef.current;
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            pdf.save(bookingDetails.travellerName + '_ticket_voucher.pdf');
        });
    };
    function getTimeFromMins(mins) {
        var h = mins / 60 | 0, m = mins % 60 | 0;
        var durationformat = h + "h " + m + "m";
        return durationformat;
    }
    const GetData = () => {
        setPageLoading(true);
        apiService.getAll(config.GETFLIGHTBOOKINGDETAILS + "/" + params.flightBookingId)
            .then((res) => {
                setBookingDetails(res);
                setItinerary(res.dcFlightLegs);
                setTravellers(res.travellerInfos);
                setPageLoading(false);
            })
            .catch((err) => console.error("Error fetching company data", err));
    }
    useEffect(() => {
        GetData();
    }, []);
    return (
        <div className="container-fluid mt-2">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">
                        {pageLoading === true ?
                            <div className="row align-items-center justify-content-center">
                                <div className="col-lg-12">
                                    <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
                                    Loading, Please wait...
                                </div>
                            </div> :
                            <div className="row align-items-center justify-content-center">
                                <div className='col-6'>
                                </div>
                                <div className='col-6'>
                                    <div className="btn-group btn-group-sm float-right d-print-none">
                                        <Link className="btn btn-primary me-2" onClick={handlePrint}>
                                            <i className="ri-printer-line"></i> Print
                                        </Link>
                                        <Link className="btn btn-primary me-2" onClick={handlePDF}>
                                            <i className="ri-file-download-line"></i> Download Voucher
                                        </Link>
                                        <Link to={"/flight/invoice/" + params.flightBookingId} className="btn btn-primary me-2">
                                            <i className="ri-file-download-line"></i> View Invoice
                                        </Link>
                                    </div>
                                </div>
                                <div ref={contentRef}>
                                    <div className="col-lg-12">
                                        <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                                            <div className='row'>
                                                <div className='col-8 text-left'>
                                                    <h4 className="text-6 mb-3 mb-sm-4">Booking Details</h4>
                                                </div>
                                                <div className='col-4 ml-auto'>
                                                     {DefaultData?.DEFAULTCOMPANYNAME}< br />
                                                    {DefaultData?.DEFAULTCOMPANYEMAIL}< br />
                                                    {DefaultData?.DEFAULTCOMPANYPHONENUMBER}< br />
                                                    {DefaultData?.DEFAULTCOMPANYGST}
                                                </div>
                                            </div>
                                            <div className="card">
                                                <hr className="mb-4" />
                                                {itinerary.length > 0 && itinerary.map(it => (
                                                    it.dcDisplayLegs?.length > 0 && it.dcDisplayLegs.map((leg, index) => (
                                                        <div className="card" key={index}>
                                                            <div className="card-body">
                                                                <div className="row align-items-center trip-title">
                                                                    <div className="col-5 col-sm-auto text-center text-sm-start">
                                                                        <h5 className="m-0 trip-place">{leg.startSegment.city}, {leg.startSegment.airportCode}</h5>
                                                                    </div>
                                                                    <div className="col-2 col-sm-auto text-8 text-black-50 text-center trip-arrow">➝</div>
                                                                    <div className="col-5 col-sm-auto text-center text-sm-start">
                                                                        <h5 className="m-0 trip-place">{leg.endSegment.city}, {leg.endSegment.airportCode}</h5>
                                                                    </div>
                                                                    <div className="col-12 mt-1 d-block d-md-none" />
                                                                    <div className="col-6 col-sm col-md-auto text-3 date">{moment(leg.startSegment.departureDateTime).format('DD MMM YY')}</div>
                                                                    <div className="col col-md-auto text-center ms-auto order-sm-0">
                                                                        {it.flightLeg?.refundable === "Refundable" ?
                                                                            <span className="badge bg-success fw-normal text-1">{it.flightLeg?.refundable}</span>
                                                                            :
                                                                            <span className="badge bg-danger fw-normal text-1">{it.flightLeg?.refundable}</span>
                                                                        }
                                                                    </div>
                                                                    <div class="col col-md-auto text-center ml-auto order-sm-0">
                                                                        <span class="badge bg-success py-1 px-2 font-weight-normal text-0">
                                                                            Confirmed <i class="fas fa-check-circle"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <p class="mt-3 line-height-4 text-1">
                                                                    PNR: {bookingDetails.pnr}<br />
                                                                    Booking No: {bookingDetails.bookingNo}<br />
                                                                    Supplier Confirmation: {bookingDetails.supplierBookingId}<br />
                                                                    Class of Service: {bookingDetails.cabinClass}</p>
                                                                <div className="flight-details">
                                                                    <div className="tab-content my-3">
                                                                        {it.dcSegments.length > 0 && it.dcSegments.map(seg =>
                                                                            <>
                                                                                <div className="row flex-row pt-4 px-md-4">
                                                                                    <div className="col-12 col-sm-3 text-center d-lg-flex company-info"> <span className="align-middle"><img className="img-fluid" alt src={"/assets/images/airlinelogos/" + seg.tFAirlineData?.airlineCode + ".png"} /> </span> <span className="align-middle ms-lg-2"> <span className="d-block text-1 text-dark">{seg.tFAirlineData?.airline}</span> <small className="text-muted d-block">{seg.tFAirlineData?.equimentType + "-" + seg.tFAirlineData?.flightNumber}</small> </span> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFDepartureData.departureDateTime).format('hh:mm A')}</span> <small className="text-muted d-block">{seg.tFDepartureData.airportName}, {seg.tFDepartureData.city}, {seg.tFDepartureData.terminal}</small> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-3 text-dark">{getTimeFromMins(seg.tFAirlineData?.duration)}</span> <small className="text-muted d-block">Duration</small> </div>
                                                                                    <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFArrivalData.arrivalDateTime).format('hh:mm A')}</span> <small className="text-muted d-block">{seg.tFArrivalData.airportName}, {seg.tFArrivalData.city},{seg.tFArrivalData.terminal}</small> </div>
                                                                                </div>
                                                                                {seg.tFAirlineData.connectingTime !== 0 ?
                                                                                    <div className="row flex-row pt-4 px-md-4">
                                                                                        <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                                                            <span className="badge bg-success">CONNECTING TIME : {getTimeFromMins(seg.tFAirlineData.connectingTime)}</span>
                                                                                        </div>
                                                                                    </div> : ''}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ))}
                                                <div className="card-body">
                                                    <h6 className="fw-semibold mb-0">Traveler Details</h6>
                                                    <div className="table-responsive-md">
                                                        <table className="table bg-white">
                                                            <thead>
                                                                <tr>
                                                                    <th>SNo.</th>
                                                                    <th>Name</th>
                                                                    <th>Gender</th>
                                                                    <th>Type</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {travellers.length > 0 && travellers.map((t, index) =>
                                                                    <tr>
                                                                        <td>{index + 1}</td>
                                                                        <td>{t.title}.{t.firstName} {t.lastName}</td>
                                                                        <td>{t.gender}</td>
                                                                        <td>{t.travelerType}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlightVoucher;
